module.exports = __webpack_public_path__ + "images/file_icons_v2/jar-9c133bf85718d7d36b5ab39679176e7a.svg";